import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-top: -1.5rem;

    @media (min-width: 768px) {
      max-width: 320px;
    }
  `}
`;

export const Content = styled.div``;

export const HeaderSingle = styled.div`
  ${({ theme }) => css`
    padding: 0.5rem 1rem;
    background-color: ${theme.colors.ultraLightGray};
  `}
`;

export const HeaderMultiple = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: 0.5rem 1rem;
    background-color: ${theme.colors.ultraLightGray};
  `}
`;

export const Form = styled.form`
  width: 100%;

  > button {
    margin-top: 1.5rem;
  }
`;

export const AboutAnimals = styled.div`
  ${({ theme }) => css`
    display: flex;

    > span {
      display: flex;
      align-items: center;
      margin-left: 0.5rem;
      font-size: 0.875rem;
    }
  `}
`;

export const ImagesAnimals = styled.div`
  ${({ theme }) => css`
    display: flex;

    img {
      height: 30px;
      width: 30px;
      border-radius: 15px;
      z-index: 1;

      &:nth-child(2) {
        margin-left: -1rem;
        z-index: 2;
      }

      &:nth-child(3) {
        margin-left: -1rem;
        z-index: 3;
      }
    }

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      border-radius: 15px;
      margin-left: -1rem;
      z-index: 4;
      background-color: ${theme.colors.lightGray};
      color: ${theme.colors.white};
    }
  `}
`;

export const NamesAnimals = styled.div`
  ${({ theme }) => css`
    margin-top: 1rem;
    color: ${theme.colors.black};
    opacity: 0.5;
    font-size: 0.75rem;
  `}
`;

export const CurrentAnimalData = styled.div`
  ${({ theme }) => css`
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 60px;
      height: 60px;
      border-radius: 30px;
    }

    > p {
      margin: 0;
    }

    > span {
      background-color: ${theme.colors.ultraLightGray};
      padding: 0.25rem 0.5rem;
      font-size: 0.75rem;
      margin: 0.5rem 0;
    }
  `}
`;
